"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspacePickerHomeFooter = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var Icon_1 = require("../Icon");
var WorkspacePickerHomeFooterComponent = function (_a) {
    var _b, _c;
    var children = _a.children, className = _a.className, href = _a.href, onClick = _a.onClick, theme = _a.theme;
    var mergedClassNames = classnames_1.default("gd-workspace-picker-home-footer", className);
    return (react_1.default.createElement("a", { className: mergedClassNames, href: href, onClick: onClick },
        react_1.default.createElement(Icon_1.Icon.Home, { className: "gd-icon-home", width: 20, height: 20, color: (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.complementary) === null || _c === void 0 ? void 0 : _c.c7 }),
        children));
};
/**
 * @internal
 */
exports.WorkspacePickerHomeFooter = sdk_ui_theme_provider_1.withTheme(WorkspacePickerHomeFooterComponent);
//# sourceMappingURL=WorkspacePickerHomeFooter.js.map